import { createUseStyles } from 'react-jss'

export const useStyle = createUseStyles({
  name: {
    marginLeft: 8
  }
})
